export default class AxiosFunction {

    static axiosGet(url, data = null) {
        if (!data) {
            return axios.get(url);
        }

        if (AxiosFunction.shouldTreatAsQueryParams(data)) {
            return axios.get(url, {params: data});
        }

        return axios.get(url, data);
    }

    static axiosPost(options) {
        return axios.post(options.url, options.data);
    }

    static axiosPut(options) {
        return axios.put(options.url, options.data);
    }

    static axiosDelete(url) {
        return axios.delete(url);
    }

    static axiosPatch(options) {
        return axios.patch(options.url, options.data);
    }

    static responseToCallback(promise, succesCallback, errorCallback) {
        promise.then(response => {
            if (succesCallback) succesCallback(true, response.data); //returns success response data
        }).catch(({response}) => {
            if (errorCallback) errorCallback(false, response.data); //returns error response data
        });
    }

    static shouldTreatAsQueryParams(data) {
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            return false;
        }

        const axiosConfigKeys = [
            'adapter',
            'auth',
            'baseURL',
            'cancelToken',
            'data',
            'decompress',
            'env',
            'formSerializer',
            'headers',
            'httpAgent',
            'httpsAgent',
            'insecureHTTPParser',
            'maxBodyLength',
            'maxContentLength',
            'maxRate',
            'method',
            'onDownloadProgress',
            'onUploadProgress',
            'params',
            'paramsSerializer',
            'proxy',
            'responseType',
            'responseEncoding',
            'signal',
            'socketPath',
            'timeout',
            'timeoutErrorMessage',
            'transformRequest',
            'transformResponse',
            'transitional',
            'transport',
            'validateStatus',
            'withCredentials',
            'xsrfCookieName',
            'xsrfHeaderName',
        ];

        return !Object.keys(data).some(key => axiosConfigKeys.includes(key));
    }
}
